// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","serif":"fonts__serif___8JVKh","sans":"fonts__sans___1IZhO","type":"\"../../shared/type.css\"","summaryContent":"summary__summaryContent___GvzSw type__headerText___1hGZ4 fonts__serif___8JVKh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Summary/summary.css
// module id = 166
// module chunks = 0